/* ===========================================================
   Storegen cart drawer - adapted 1:1 from Harper Australia.
   Self-contained, no dependencies. Shipping Protection + upsell removed.
   =========================================================== */
(function () {
  'use strict';

  var CFG = window.SGCART_CONFIG || {};
  var TIERS = (CFG.tiers || [{ qty: 2, pct: 10 }, { qty: 3, pct: 15 }, { qty: 4, pct: 20 }])
    .filter(function (t) { return t.enabled !== false; })
    .slice().sort(function (a, b) { return a.qty - b.qty; });
  var MONEY_FORMAT = String(CFG.moneyFormat || '${{amount}}').replace(/<[^>]+>/g, '').trim();
  var SECTION = 'sg-cart-items';
  var TIMER_ENABLED = CFG.timer_enabled !== false;
  var TIMER_TOTAL = (CFG.timer_minutes || 10) * 60;

  var lastCart = CFG.cart || null;
  var lastHtml  = null;   // cached section HTML - avoids loader on re-open
  var timerInt = null;
  var timerStart = null;
  var chain = Promise.resolve();   // serial queue - cart mutations run one after another
  var inflight = 0;
  var loaderTimer = null;

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function el() { return document.getElementById('SGCartDrawer'); }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace(/[^0-9.-]/g, '');
    var n = Number(cents); if (isNaN(n)) n = 0;
    var rx = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(num, p, t, d) {
      t = t || ','; d = d || '.';
      var parts = (num / 100).toFixed(p).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return dollars + (parts[1] ? d + parts[1] : '');
    }
    var m = MONEY_FORMAT.match(rx), key = m ? m[1] : 'amount', v;
    switch (key) {
      case 'amount_no_decimals': v = fmt(n, 0); break;
      case 'amount_with_comma_separator': v = fmt(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(n, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(n, 2, ' ', '.'); break;
      default: v = fmt(n, 2);
    }
    return MONEY_FORMAT.replace(rx, v);
  }
  /* loader overlay - only appears if an operation takes longer than 250ms */
  function showLoader(state) {
    var d = el(); if (!d) return;
    if (state) {
      if (!loaderTimer) loaderTimer = setTimeout(function () { d.classList.add('is-busy'); }, 250);
    } else {
      if (loaderTimer) { clearTimeout(loaderTimer); loaderTimer = null; }
      d.classList.remove('is-busy');
    }
  }
  /* every cart mutation goes through this serial queue, so a click is never
     dropped while another request is still running */
  function enqueue(task) {
    inflight++;
    showLoader(true);
    var run = function () {
      return new Promise(function (resolve) {
        var done = false;
        var finish = function () { if (!done) { done = true; resolve(); } };
        var guard = setTimeout(finish, 14000);
        Promise.resolve().then(task).then(
          function () { clearTimeout(guard); finish(); },
          function () { clearTimeout(guard); finish(); }
        );
      });
    };
    chain = chain.then(run, run).then(function () {
      inflight--;
      if (inflight <= 0) { inflight = 0; showLoader(false); }
    });
    return chain;
  }

  /* Compte d'articles dans le panier */
  function realCount(cart) {
    if (!cart) return 0;
    return Math.max(0, Number(cart.item_count) || 0);
  }

  /* ---------- cart API ---------- */
  function api(url, opts) {
    opts = opts || {};
    if (typeof AbortController !== 'undefined') {
      var ctrl = new AbortController();
      opts.signal = ctrl.signal;
      setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 10000);
    }
    return window.fetch(url, opts);
  }
  function jsonPost(url, body) {
    return api(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {})
    });
  }
  function sectionHTML(cart) {
    var raw = cart && cart.sections && cart.sections[SECTION];
    if (!raw) return null;
    var tmp = document.createElement('div');
    tmp.innerHTML = raw;
    var inner = tmp.querySelector('#shopify-section-' + SECTION);
    return inner ? inner.innerHTML : raw;
  }
  /* Parse the embedded cart state from the section HTML - 1 round-trip not 2. */
  function parseCart(itemsHtml) {
    if (!itemsHtml) return null;
    var tmp = document.createElement('div');
    tmp.innerHTML = itemsHtml;
    var s = tmp.querySelector('[data-sg-cart]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function refresh() {
    return enqueue(function () {
      return jsonPost('/cart/update.js', { sections: SECTION, sections_url: '/cart' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { applyState(cart, sectionHTML(cart)); });
    });
  }

  /* ---------- open / close ---------- */
  function openDrawer() {
    var d = el(); if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sgcart-lock');
  }
  function open() {
    openDrawer();
    // Silent sync - no loader, drawer shows server-side items immediately
    jsonPost('/cart/update.js', { sections: SECTION, sections_url: '/cart' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyState(cart, sectionHTML(cart)); })
      .catch(function () {});
  }
  function close() {
    var d = el(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sgcart-lock');
  }

  /* ---------- progress bar ---------- */
  function buildBar() {
    var bar = $('[data-sgcart-bar]', el());
    if (!bar || (bar.children && bar.children.length)) return;
    var n = TIERS.length;
    var html = '<div class="sgcart__bar-track"><div class="sgcart__bar-fill" data-sgcart-fill></div></div><div class="sgcart__nodes">';
    TIERS.forEach(function (t, i) {
      html += '<div class="sgcart__node" data-tier="' + i + '" style="left:' + ((i + 1) * (100 / n)) + '%">' +
                '<span class="sgcart__node-dot"></span><span class="sgcart__node-label">' + t.pct + '%</span></div>';
    });
    bar.innerHTML = html + '</div>';
  }
  function currentTier(c) { var r = null; TIERS.forEach(function (t) { if (c >= t.qty) r = t; }); return r; }
  function nextTier(c) { for (var i = 0; i < TIERS.length; i++) { if (c < TIERS[i].qty) return TIERS[i]; } return null; }

  function renderProgress(count) {
    var d = el();
    var progEl = $('[data-sgcart-progress]', d);
    // Hide progress bar entirely when no tiers configured
    if (!TIERS.length) { if (progEl) progEl.style.display = 'none'; return; }
    if (progEl) progEl.style.display = '';

    var fill = $('[data-sgcart-fill]', d), msg = $('[data-sgcart-msg]', d);
    var n = TIERS.length, maxQty = TIERS[n - 1].qty;
    var cur = currentTier(count), nxt = nextTier(count);
    var pct;
    if (count >= maxQty) { pct = 100; }
    else {
      var seg = 0, startQty = 0, endQty = TIERS[0].qty, prev = 0;
      for (var k = 0; k < n; k++) {
        if (count < TIERS[k].qty) { seg = k; startQty = prev; endQty = TIERS[k].qty; break; }
        prev = TIERS[k].qty;
      }
      var segW = 100 / n;
      pct = (seg * segW) + (((count - startQty) / (endQty - startQty)) * segW);
    }
    if (fill) fill.style.width = Math.max(0, Math.min(100, pct)) + '%';

    var m = '';
    if (count > 0) {
      if (cur && nxt) {
        var need = nxt.qty - count;
        m = nxt.text
          ? nxt.text.replace('{n}', need)
          : '<span class="sgcart__msg-win">' + cur.pct + '% débloqué</span> &mdash; ajoute <strong>' + need + '</strong> article' + (need > 1 ? 's' : '') + ' pour <strong>' + nxt.pct + '% de remise</strong>';
      } else if (cur && !nxt) {
        m = cur.text || ('<span class="sgcart__msg-win">Tu as débloqué la remise max de ' + cur.pct + '%</span>');
      } else if (nxt) {
        var need2 = nxt.qty - count;
        m = nxt.text
          ? nxt.text.replace('{n}', need2)
          : 'Ajoute <strong>' + need2 + '</strong> article' + (need2 > 1 ? 's' : '') + ' pour débloquer <strong>' + nxt.pct + '% de remise</strong>';
      }
    }
    if (msg) msg.innerHTML = m;
    $$('.sgcart__node', d).forEach(function (node, i) {
      node.classList.toggle('is-reached', count >= TIERS[i].qty);
    });
  }

  /* ---------- line item fallback (Agent 1 & Agent 3 harmonisés) ---------- */
  function itemHTML(item) {
    var img = sized(item.image, 200);
    var opts = "";
    if (item.options_with_values && item.options_with_values.length) {
      opts = item.options_with_values
        .filter(function (o) { return o.value && o.value !== "Default Title"; })
        .map(function (o) {
          var nameLow = (o.name || "").toLowerCase();
          if (nameLow.indexOf("couleur") !== -1 || nameLow.indexOf("color") !== -1) {
            var valLow = (o.value || "").toLowerCase().trim();
            var hex = "#d9c8b4";
            if (valLow.indexOf("noir") !== -1 || valLow.indexOf("black") !== -1) hex = "#1a1a1a";
            else if (valLow.indexOf("rouge") !== -1 || valLow.indexOf("red") !== -1) hex = "#c93b3b";
            else if (valLow.indexOf("bleu") !== -1 || valLow.indexOf("blue") !== -1) hex = "#3b6fa0";
            else if (valLow.indexOf("beige") !== -1 || valLow.indexOf("nude") !== -1) hex = "#d9c8b4";
            return "<span class=\"sgcart-color-badge\"><span class=\"sgcart-color-badge__dot\" style=\"background-color:" + hex + "\"></span><span class=\"sgcart-color-badge__text\">" + escapeHtml(o.value) + "</span></span>";
          }
          return "<span class=\"sgcart-opt\"><span class=\"sgcart-opt__k\">" + escapeHtml(o.name) + " :</span> <strong class=\"sgcart-opt__v\">" + escapeHtml(o.value) + "</strong></span>";
        }).join("<span class=\"sgcart-opt__sep\"> &middot; </span>");
    } else if (item.variant_title && item.variant_title !== "Default Title") {
      var parts = item.variant_title.split("/").map(function (s) { return s.trim(); });
      if (parts.length >= 2) {
        var colVal = parts[0];
        var colLow = colVal.toLowerCase();
        var hex = "#d9c8b4";
        if (colLow.indexOf("noir") !== -1 || colLow.indexOf("black") !== -1) hex = "#1a1a1a";
        else if (colLow.indexOf("rouge") !== -1 || colLow.indexOf("red") !== -1) hex = "#c93b3b";
        else if (colLow.indexOf("bleu") !== -1 || colLow.indexOf("blue") !== -1) hex = "#3b6fa0";
        else if (colLow.indexOf("beige") !== -1 || colLow.indexOf("nude") !== -1) hex = "#d9c8b4";
        var colBadge = "<span class=\"sgcart-color-badge\"><span class=\"sgcart-color-badge__dot\" style=\"background-color:" + hex + "\"></span><span class=\"sgcart-color-badge__text\">" + escapeHtml(colVal) + "</span></span>";
        var sizeBadge = "<span class=\"sgcart-opt\"><span class=\"sgcart-opt__k\">Taille :</span> <strong class=\"sgcart-opt__v\">" + escapeHtml(parts[1]) + "</strong></span>";
        opts = colBadge + "<span class=\"sgcart-opt__sep\"> &middot; </span>" + sizeBadge;
      } else {
        opts = "<span class=\"sgcart-opt\"><strong class=\"sgcart-opt__v\">" + escapeHtml(item.variant_title) + "</strong></span>";
      }
    }

    var isFree = (item.final_line_price === 0 || item.final_price === 0);
    var unitPrice = Number(item.original_price !== undefined ? item.original_price : (item.price || 0));

    var priceHtml = "";
    if (isFree) {
      priceHtml = "<span class=\"sgcart-badge--pack-free\">" +
        "<svg width=\"12\" height=\"12\" viewBox=\"0 0 16 16\" fill=\"currentColor\" aria-hidden=\"true\" style=\"margin-right:4px;\">" +
          "<path d=\"M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.5h1.5a1.5 1.5 0 0 1 1.5 1.5V6a1.5 1.5 0 0 1-1.5 1.5H1v-1.5A1.5 1.5 0 0 1 2.5 4.5H4v-.5A2.5 2.5 0 0 1 3 2.5zm5 0a1.5 1.5 0 1 0-3 0v.5h3v-.5zm1 0v.5h3v-.5a1.5 1.5 0 1 0-3 0z\"/>" +
          "<path d=\"M2 8.5h5.5V14H3a1 1 0 0 1-1-1V8.5zm7 5.5V8.5H14.5v4.5a1 1 0 0 1-1 1H9z\"/>" +
        "</svg>" +
        "Offert (Inclus dans votre pack)</span>" +
        "<span class=\"sgcart-item__now sgcart-item__now--free\">Gratuit</span>";
    } else {
      priceHtml = "<span class=\"sgcart-item__now\">" + formatMoney(unitPrice) + "</span>";
    }

    return "<div class=\"sgcart-item" + (isFree ? " sgcart-item--free" : "") + "\" data-key=\"" + escapeHtml(item.key) + "\">" +
        "<a class=\"sgcart-item__img\" href=\"" + escapeHtml(item.url) + "\">" +
          (img ? "<img src=\"" + escapeHtml(img) + "\" alt=\"\" loading=\"lazy\">" : "") + "</a>" +
        "<div class=\"sgcart-item__info\">" +
          "<a class=\"sgcart-item__title\" href=\"" + escapeHtml(item.url) + "\">" + escapeHtml(item.product_title || item.title) + "</a>" +
          (opts ? "<div class=\"sgcart-item__opts\">" + opts + "</div>" : "") +
          "<div class=\"sgcart-item__price\">" + priceHtml + "</div>" +
          "<div class=\"sgcart-item__qty\">" +
            "<button type=\"button\" class=\"sgcart-qty__btn\" data-sgcart-minus aria-label=\"Diminuer la quantité\">−</button>" +
            "<span class=\"sgcart-qty__val\">" + item.quantity + "</span>" +
            "<button type=\"button\" class=\"sgcart-qty__btn\" data-sgcart-plus aria-label=\"Augmenter la quantité\"" + (isFree ? " disabled style=\"opacity:0.35;cursor:not-allowed;\"" : "") + ">+</button>" +
          "</div>" +
        "</div>" +
        "<button type=\"button\" class=\"sgcart-item__remove\" data-sgcart-remove aria-label=\"Retirer l’article\">" +
          "<svg viewBox=\"0 0 24 24\" width=\"17\" height=\"17\" aria-hidden=\"true\"><path d=\"M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3\" stroke=\"currentColor\" stroke-width=\"1.6\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>" +
        "</button>" +
      "</div>";
  }
  function fallbackItems(cart) {
    return (cart.items || []).map(itemHTML).join("");
  }

  /* ---------- countdown timer ---------- */
  function timerTick() {
    var d = el(); if (!d) return;
    if (!timerStart) { timerStart = Date.now(); }
    try {
      var stored = sessionStorage.getItem('sgcart_timer_start');
      if (stored) { timerStart = Number(stored); }
      else { sessionStorage.setItem('sgcart_timer_start', String(timerStart)); }
    } catch (e) {}
    var left = Math.max(0, TIMER_TOTAL - Math.floor((Date.now() - timerStart) / 1000));
    var mm = Math.floor(left / 60), ss = left % 60;
    var val = $('[data-sgcart-timer-val]', d);
    if (val) val.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
    if (left <= 0) {
      var strip = $('[data-sgcart-timer]', d);
      if (strip) strip.classList.add('is-expired');
      if (timerInt) { clearInterval(timerInt); timerInt = null; }
      // Loop: restart after 1.5s pause
      setTimeout(function () {
        timerReset();
        var d2 = el(); if (!d2) return;
        var te = $('[data-sgcart-timer]', d2);
        if (te && !te.hidden) timerEnsure();
      }, 1500);
    }
  }
  function timerEnsure() { if (!TIMER_ENABLED || timerInt) return; timerTick(); timerInt = setInterval(timerTick, 1000); }
  function timerReset() {
    timerStart = null;
    try { sessionStorage.removeItem('sgcart_timer_start'); } catch (e) {}
    if (timerInt) { clearInterval(timerInt); timerInt = null; }
    var s = $('[data-sgcart-timer]', el());
    if (s) s.classList.remove('is-expired');
  }

  /* ---------- apply cart state ---------- */
  function applyState(cart, itemsHtml) {
    if (!cart) return;
    lastCart = cart;
    if (itemsHtml) lastHtml = itemsHtml;
    var d = el(); if (!d) return;
    var count = realCount(cart);

    var itemsEl = $('[data-sgcart-items]', d);
    if (itemsEl && itemsHtml !== undefined) {
      itemsEl.innerHTML = itemsHtml ? itemsHtml : fallbackItems(cart);
    }

    var countEl = $('[data-sgcart-count]', d);
    if (countEl) countEl.textContent = count;

    var emptyEl = $('[data-sgcart-empty]', d);
    var footEl = $('.sgcart__foot', d);
    var progEl = $('[data-sgcart-progress]', d);
    var timerEl = $('[data-sgcart-timer]', d);

    if (count === 0) {
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.style.display = 'none';
      if (progEl) progEl.style.display = 'none';
      if (timerEl) timerEl.hidden = true;
      timerReset();
    } else {
      if (emptyEl) emptyEl.hidden = true;
      if (footEl) footEl.style.display = '';
      if (progEl) progEl.style.display = '';
      if (timerEl) timerEl.hidden = !TIMER_ENABLED;
      timerEnsure();
    }

    renderProgress(count);

    var itemsSubtotal = 0;
    var itemsFinal = 0;

    if (cart.items && cart.items.length) {
      cart.items.forEach(function (it) {
        var itOrigLine = (it.original_line_price !== undefined) ? Number(it.original_line_price) : ((Number(it.original_price || it.price) || 0) * (it.quantity || 1));
        var itFinalLine = (it.final_line_price !== undefined) ? Number(it.final_line_price) : ((Number(it.final_price !== undefined ? it.final_price : it.price) || 0) * (it.quantity || 1));
        itemsSubtotal += itOrigLine;
        itemsFinal += itFinalLine;
      });
    }

    var realDiscount = Math.max(0, itemsSubtotal - itemsFinal);
    if (realDiscount === 0 && Number(cart.total_discount) > 0) {
      realDiscount = Number(cart.total_discount);
      if (itemsSubtotal === Number(cart.total_price)) {
        itemsSubtotal = Number(cart.total_price) + realDiscount;
      }
    }

    var totalPrice = Number(cart.total_price) || (itemsSubtotal - realDiscount);

    // Récapitulatif limpide, carré, sans faux calculs comparatifs
    var orig = $("[data-sgcart-original]", d);
    if (orig) orig.textContent = formatMoney(itemsSubtotal > 0 ? itemsSubtotal : (cart.original_total_price || totalPrice));
    var tot = $("[data-sgcart-total]", d);
    if (tot) tot.textContent = formatMoney(totalPrice);
    var coT = $("[data-sgcart-checkout-total]", d);
    if (coT) coT.textContent = formatMoney(totalPrice);

    var discRow = $("[data-sgcart-discount-row]", d);
    var discEl = $("[data-sgcart-discount]", d);
    if (discRow && discEl) {
      if (realDiscount > 0) {
        discRow.hidden = false;
        discEl.textContent = "−" + formatMoney(realDiscount);
      } else {
        discRow.hidden = true;
      }
    }
  }

  /* ---------- cart mutations ---------- */
  function changeQty(key, qty) {
    enqueue(function () {
      return jsonPost('/cart/change.js', { id: key, quantity: qty, sections: SECTION, sections_url: '/cart' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { timerReset(); applyState(cart, sectionHTML(cart)); });
    });
  }

  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    var label = btn ? btn.textContent : '';
    enqueue(function () {
      return jsonPost('/cart/add.js', { id: variantId, quantity: qty || 1, sections: SECTION, sections_url: '/cart' })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) {
            if (btn) {
              var desc = (res.data && (res.data.description || res.data.message) || '').toLowerCase();
              btn.textContent = /stock|sold/.test(desc) ? 'Épuisé' : 'Indisponible';
              setTimeout(function () { btn.textContent = label || 'Ajouter'; }, 2200);
            }
            return;
          }
          if (btn) {
            btn.textContent = '✓ Ajouté';
            setTimeout(function () { btn.textContent = label || 'Ajouter'; }, 1500);
          }
          timerReset();
          var html = sectionHTML(res.data);
          var cart = parseCart(html);
          if (cart && html) { applyState(cart, html); }
          else { return refresh(); }
        });
    });
  }

  /* Add to cart straight from a product <form> - bypasses the theme's own handler. */
  function addFromForm(form) {
    openDrawer();
    var d = el(); if (d) d.classList.add('is-busy');
    enqueue(function () {
      var fd = new FormData(form);
      fd.append('sections', SECTION);
      fd.append('sections_url', '/cart');
      return api('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          var dd = el(); if (dd) dd.classList.remove('is-busy');
          if (!res.ok) { return refresh(); }
          timerReset();
          var html = sectionHTML(res.data);
          var cart = parseCart(html);
          if (cart && html) { applyState(cart, html); }
          else { return refresh(); }
        }, function () {
          var dd = el(); if (dd) dd.classList.remove('is-busy');
        });
    });
  }

  /* ---------- delegated events ---------- */
  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-sgcart-close]')) { close(); return; }
    if (t.closest('[data-sgcart-checkout]')) { window.location.href = '/checkout'; return; }

    var itemEl = t.closest('.sgcart-item');
    if (itemEl) {
      var key = itemEl.getAttribute('data-key');
      var item = lastCart && lastCart.items.filter(function (i) { return i.key === key; })[0];
      var q = item ? item.quantity : 1;
      if (t.closest('[data-sgcart-plus]'))   { changeQty(key, q + 1); return; }
      if (t.closest('[data-sgcart-minus]'))  { changeQty(key, Math.max(0, q - 1)); return; }
      if (t.closest('[data-sgcart-remove]')) { changeQty(key, 0); return; }
    }
  }
  function onDocClickCapture(e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || !t.closest) return;
    // Check specific selectors first (fast path)
    var a = t.closest([
      '.js-drawer-open-cart',
      '[data-sgcart-open]',
      '[data-sg-cart-open]',
      '.sg-header__cart',
      '[data-testid="cart-drawer-trigger"]',
      '.action__cart',               // Horizon 4 page-mode cart link class
      '.header-actions__cart-icon'   // inner cart-icon element
    ].join(','));
    if (!a) {
      // Fallback: any <a href="/cart"> (Horizon 4 page mode)
      var link = t.closest('a');
      if (link && /^\/cart(\/|\?|$)/.test(link.getAttribute('href') || '')) a = link;
    }
    if (!a) return;
    if (a.hasAttribute('data-no-drawer')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }

  /* ---------- neutralise the theme's native cart drawer ---------- */
  function neutralizeNativeDrawer() {
    var de = document.documentElement;
    function strip() {
      if (de.classList.contains('js-drawer-open')) de.classList.remove('js-drawer-open');
      if (de.classList.contains('js-drawer-closing')) de.classList.remove('js-drawer-closing');
      if (document.body && document.body.classList.contains('js-drawer-open')) {
        document.body.classList.remove('js-drawer-open');
      }
    }
    strip();
    try {
      var obs = new MutationObserver(strip);
      obs.observe(de, { attributes: true, attributeFilter: ['class'] });
      if (document.body) obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }

  /* ---------- init ---------- */
  function init() {
    var d = el(); if (!d) return;
    if (d.parentNode !== document.body) document.body.appendChild(d);
    neutralizeNativeDrawer();
    buildBar();
    timerReset(); // always start fresh on page load - avoids stale sessionStorage showing 00:00 instantly
    applyState(CFG.cart);
    // Direct listeners on close triggers (bulletproof - bypass delegation issues)
    $$('[data-sgcart-close]', d).forEach(function (closeEl) {
      closeEl.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(); });
      closeEl.addEventListener('touchend', function (e) { e.preventDefault(); e.stopPropagation(); close(); });
    });
    // Delegated capture - also handles dynamically added items
    d.addEventListener('click', onClick, true);
    document.addEventListener('click', onDocClickCapture, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) close();
    });
    /* take over every product add-to-cart form (capture phase, before the theme) */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addFromForm(form);
    }, true);
  }

  window.SGCart = { open: open, close: close, refresh: refresh };
  window.HFCart = { open: open, close: close, refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      try { init(); } catch (e) { console.error("SGCart init error:", e); }
    });
  } else {
    try { init(); } catch (e) { console.error("SGCart init error:", e); }
  }
})();
